import { type SearchParams, type SearchResponse } from 'meilisearch';

import { getMeilisearchClient } from '@/lib/api/meilisearch-client';

import type { Meilisearch_ShippingCountry } from './meilisearch-types';

export const fetchShippingCountries = async (
  countryName: string,

  { limit, offset, page, attributesToRetrieve = [] }: SearchParams,
): Promise<SearchResponse<Meilisearch_ShippingCountry>> => {
  const searchClient = getMeilisearchClient();

  // Call the function with the desired document ID
  const articles = await searchClient
    .index<Meilisearch_ShippingCountry>('shipping_countries')
    .search(countryName, {
      // filter: `fr.nom = ${countryName}`,
      // sort: ['code_iso:desc'],
      attributesToRetrieve: [
        'id',
        'fr.nom',
        'en.nom',
        'nom_local',
        'actif',
        'code_iso',
        ...attributesToRetrieve,
      ],
      limit,
      offset,
      page,
    });

  return articles;
};
